import { useQuery } from '@tanstack/react-query';

import { GLOBAL_API_BASE_URL } from '@chk/env-variables';
import { getGlobalAPIHeaders } from '@data/global-api-common';
import { asyncFetch, validateSchema } from '@utility/checkout-utils';

import { GLOBAL_API_ACCOUNT_ACCESS_ENDPOINTS } from '../../constants/endpoints';
import { POLLING_INTERVAL_IN_MS } from '../../constants/polling';
import { ACCOUNT_ACCESS_TAGS } from '../../constants/tags';
import { GlobalApiAccountAccessSchema } from '../../schemas/GlobalApiAccountAccess';
import { shouldPollAccountAccess } from '../../utils/shouldPollAccountAccessDetails/shouldPollAccountAccessDetails';

import type { GetGlobalApiAccountAccessParams } from './useGetGlobalApiAccountAccess.types';

export const useGetGlobalApiAccountAccess = ({
  accountAccessId,
  authToken,
  voltApp,
  enabled,
}: GetGlobalApiAccountAccessParams) => {
  return useQuery({
    queryKey: ACCOUNT_ACCESS_TAGS.GLOBAL_API(accountAccessId),
    queryFn: () =>
      asyncFetch(
        `${GLOBAL_API_ACCOUNT_ACCESS_ENDPOINTS.get(accountAccessId)}`,
        {
          method: 'GET',
          headers: getGlobalAPIHeaders({
            authToken,
            voltApp,
            voltService: 'ais',
          }),
        },
        GLOBAL_API_BASE_URL,
        true
      ).then(validateSchema(GlobalApiAccountAccessSchema)),
    enabled,
    refetchInterval: (query) =>
      shouldPollAccountAccess(query.state.data)
        ? POLLING_INTERVAL_IN_MS
        : false,
  });
};
